export default __webpack_public_path__ + "static/9-c1ce2fa2bf5439c9f1d3a76d76f68291.png";